import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = {
  class: "text-dark",
  "data-testid": "back-to-pnls-link"
}
const _hoisted_5 = { class: "col-lg-6 text-right align-self-end" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = {
  class: "error",
  "data-testid": "name-error"
}
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = {
  class: "error",
  "data-testid": "columns-error"
}

import { computed, watch, onMounted, ref } from 'vue'
    import { useRoute } from 'vue-router'
    import { SavingState } from '@common/Common'
    import CorporateNavigation from "@common/Components/CorporateNavigation.vue"
    import SaveButton from '@common/Components/SaveButton.vue'
    import { useCorporatePnlTemplateByIdQueryV1 } from '@Quest/Pnls/queries-vue-composables'
    import { useUpdatePnlCommandV1 } from '@Quest/Pnls/commands-vue-composables'
    import type { CorporatePnlTemplateReadModel } from '@Quest/Pnls/readmodels'
    import type { ValidationError } from '@common/types'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PnlEditPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const strategyId = computed(() => String(route.params.strategyId ?? ''))
    const pnlId = computed(() => String(route.params.pnlId ?? ''))

    const initialized = ref<boolean>(false)
    const name = ref<string>('')
    const startYear = ref<number | null>(null)
    const startMonth = ref<number | null>(null)
    const columns = ref<string | null>(null)

    const savingState = ref<SavingState>(SavingState.Pending)
    const errors = ref<ValidationError[]>([])
    const nameError = computed(() => errors.value.find(e => e.ErrorCode.startsWith("Name."))?.Error ?? null)
    const columnsError = computed(() => errors.value.find(e => e.ErrorCode.startsWith("Columns."))?.Error ?? null)


    const {
        runCorporatePnlTemplateByIdQueryV1,
        modelCorporatePnlTemplateByIdQueryV1
    } = useCorporatePnlTemplateByIdQueryV1(workspaceId, strategyId, pnlId)

    const {
        invokeUpdatePnlCommandV1,
        onSucceedUpdatePnlCommandV1,
        validationErrorsUpdatePnlCommandV1
    } = useUpdatePnlCommandV1(workspaceId, strategyId, pnlId, name, startYear, startMonth, columns)

    function handleUpdatePnlCommand()
    {
        errors.value = [];
        savingState.value = SavingState.InProgress
        invokeUpdatePnlCommandV1()
    }


    onMounted(() =>
    {
        document.title = "Edit P&L | TransparentChoice"
        runCorporatePnlTemplateByIdQueryV1()
    })

    watch(modelCorporatePnlTemplateByIdQueryV1, (rm: CorporatePnlTemplateReadModel | null) =>
    {
        if (rm)
        {
            name.value = rm.Name
            startYear.value = rm.StartYear
            startMonth.value = rm.StartMonth
            columns.value = rm.Columns
            initialized.value = true
        }
    })

    onSucceedUpdatePnlCommandV1(() =>
    {
        savingState.value = SavingState.Pending
        alert('Saved')
    })

    watch(validationErrorsUpdatePnlCommandV1, (validationErrors) =>
    {
        if (!validationErrors || validationErrors.length === 0) return
        errors.value = validationErrors
        savingState.value = SavingState.Pending
    })



return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CorporateNavigation, { ActivePage: "strategy" }),
    (initialized.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(handleUpdatePnlCommand, ["prevent"]),
            "data-testid": "edit-pnl-form"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h6", null, [
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_4, [...(_cache[4] || (_cache[4] = [
                    _createElementVNode("i", {
                      class: "fa fa-angle-double-left",
                      "aria-hidden": "true"
                    }, null, -1 /* CACHED */),
                    _createTextVNode(" Back to P&Ls ", -1 /* CACHED */)
                  ]))])), [
                    [_directive_sanitizedHref, `/#/enterprise/pnls/${workspaceId.value}/${strategyId.value}`]
                  ])
                ]),
                _cache[5] || (_cache[5] = _createElementVNode("h1", {
                  style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"},
                  "data-testid": "page-heading"
                }, "Edit P&L template", -1 /* CACHED */))
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(SaveButton, {
                  savingState: savingState.value,
                  isFormSubmit: true,
                  "data-testid": "save-button"
                }, null, 8 /* PROPS */, ["savingState"])
              ])
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_6, [
              _cache[6] || (_cache[6] = _createElementVNode("label", null, "Name:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                class: "form-control",
                required: "",
                "data-testid": "name-input"
              }, null, 512 /* NEED_PATCH */), [
                [
                  _vModelText,
                  name.value,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_7, _toDisplayString(nameError.value), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[7] || (_cache[7] = _createElementVNode("label", null, "Start year:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((startYear).value = $event)),
                class: "form-control",
                min: "2023",
                max: "2100",
                step: "1",
                "data-testid": "start-year-input"
              }, null, 512 /* NEED_PATCH */), [
                [
                  _vModelText,
                  startYear.value,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[9] || (_cache[9] = _createElementVNode("label", null, "Start month:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((startMonth).value = $event)),
                "data-testid": "start-month-select"
              }, [
                _cache[8] || (_cache[8] = _createElementVNode("option", { value: null }, "Current month (dynamic)", -1 /* CACHED */)),
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
                  return _createElementVNode("option", {
                    key: i,
                    value: i
                  }, _toDisplayString(i), 9 /* TEXT, PROPS */, _hoisted_10)
                }), 64 /* STABLE_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, startMonth.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[10] || (_cache[10] = _createElementVNode("label", null, "Columns:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((columns).value = $event)),
                class: "form-control",
                required: "",
                "data-testid": "columns-input"
              }, null, 512 /* NEED_PATCH */), [
                [
                  _vModelText,
                  columns.value,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_12, _toDisplayString(columnsError.value), 1 /* TEXT */)
            ])
          ], 32 /* NEED_HYDRATION */)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})